<app-icon [iconName]="iconName" (click)="toggleMenuState()"></app-icon>